import React from "react";

import NotificationListener from "../views/pages/Sales1/emailsocket";
import ChatSocketListener from "../views/pages/Chat/ChatSocketListener";
import WhatsAppSocketListener from "../views/pages/WhatsApp/WhatsAppSocketListener";

/**
 * WebtopGlobalListeners — the app-level live listeners that the legacy shell
 * mounts at the bottom of MainLayout (Routes/Appcontainer/index.jsx):
 *
 *   <NotificationListener />  — connects the socket, joins the user's room,
 *                               receives live notifications + plays the alert
 *                               sound. Feeds state.emailSocket (the same store
 *                               the webtop tray bell reads).
 *   <ChatSocketListener />    — live chat socket + chat alert sound. Feeds
 *                               state.chat (the webtop tray chat badge reads it).
 *
 * NOTE: the legacy floating <ChatWidget /> FAB is intentionally NOT rendered on
 * the webtop — chat is surfaced through a Windows-11 tray icon + ChatFlyout
 * (webtop/taskbar/ChatFlyout.jsx) instead. The shared ChatWidget is untouched so
 * the legacy app is unaffected (Rule 4). Only the live sockets live here.
 *
 * The webtop is mounted at /webtop OUTSIDE the legacy tab system, so MainLayout
 * never renders there — without these the real-time features (notification push,
 * live chat, lead:created/updated) were silent. On /webtop the legacy MainLayout
 * is not mounted (separate route), so there is no double-mount / double-socket.
 */
const WebtopGlobalListeners = () => (
  <>
    <NotificationListener />
    <ChatSocketListener />
    <WhatsAppSocketListener />
  </>
);

export default WebtopGlobalListeners;
